import React from 'react';

// Assets
import styles from "./styles.module.css";

export default function FormError(props) {
    return <div className={styles.error}>{props.children}</div>
}
